module.exports = __webpack_public_path__ + "static/media/2-xs.ef0c1507.jpg";